import React from 'react';
import { combineClassNames } from 'core/css';
import { GridCardSecondarySection } from '../../components/cards/gridCard/GridCard';
import Spinner from '../spinner/Spinner';

export const LoadingNav = () => {
  return (
    <>
      <div className="utility-bar-container utility-bar-container--loading">
        <div className="utility-bar__header--loading" />
        <LoadingIconLink className="loading--static" />
      </div>
      <div className="step-nav-container">
        <div className="step-nav">
          <nav className="step-nav__bar">
            <div className="step-nav__outer step-nav__outer--loading" />
            <div className="step-nav__outer step-nav__outer--loading" />
            <div className="step-nav__outer step-nav__outer--loading" />
            <div className="step-nav__outer step-nav__outer--loading" />
            <div className="step-nav__outer step-nav__outer--loading" />
            <div className="step-nav__outer step-nav__outer--loading" />
          </nav>
        </div>
      </div>
    </>
  );
};

export const LoadingHeader = ({ className }) => (
  <div className={combineClassNames('loading-header', className)}></div>
);
export const LoadingDescription = ({ className }) => (
  <div className={combineClassNames('loading-description', className)}></div>
);

export const LoadingImage = ({ className }) => (
  <div className={combineClassNames('loading-image', className)}></div>
);

export const LoadingIcon = ({ className }) => (
  <div className={combineClassNames('loading-icon', className)}></div>
);

export const LoadingImageWithSpinner = ({ className }) => (
  <div
    className={combineClassNames('loading-image-spinner-container', className)}>
    <Spinner className="loading-image__spinner" />
  </div>
);

export const LoadingIconLink = ({ className }) => (
  <div className={combineClassNames('loading-icon-link', className)}></div>
);

export const LoadingCard = ({ className, type }) => (
  <div className={combineClassNames('card-container loading-card', className)}>
    <LoadingImage className={`loading-image--${type}`} />
    <div className={`loading-card-primary--${type}`}>
      <LoadingHeader className="loading-header--card" />
      <LoadingDescription className="loading-description--card" />
    </div>
    {type !== 'option-card' && (
      <GridCardSecondarySection>
        <div className="loading-card-secondry--selection"></div>
        <div className="loading-card-secondry--selection"></div>
      </GridCardSecondarySection>
    )}
  </div>
);

export const LoadingModalHeader = () => (
  <div className="modal-header modal-header--loading">
    <LoadingDescription className="loading-description--medium" />
    <LoadingIcon />
  </div>
);

export const LoadingButton = ({ className }) => (
  <div
    className={combineClassNames('button', 'loading-button', className)}></div>
);

export const LoadingAccordionItem = () => (
  <div className="compare__accordion-item compare__accordion-item--loading">
    <div className="accordion-title stat-expand-icon">
      <LoadingIcon className="accordion-header-button accordion-header-button--loading" />
      <LoadingDescription className="loading-description--medium" />
    </div>
  </div>
);
